//@flow
import { PerspectiveMercatorViewport } from 'viewport-mercator-project'
import { scalePow } from 'd3-scale'
import Map from './Map'
import { SMALL_COMPANY, MIDDLE_COMPANY, LARGE_COMPANY } from '../../constants'

type viewportType = {
  latitude: number,
  longitude: number,
  zoom: number,
  width: number,
  height: number,
}

type boundsType = {
  lat: [number, number],
  lng: [number, number],
}
// Returns a zero-based integer for the company size
export const employeesToNumber = (size: string) =>
  [SMALL_COMPANY, MIDDLE_COMPANY, LARGE_COMPANY].indexOf(size)

export const scale = scalePow()
  .domain([0, 3])
  .range([0, 10000])
  .exponent(3)

export const getMarkerSize = (size: string) => {
  const n = employeesToNumber(size)
  const s = scale(n + 1 || 1)
  return Math.sqrt(s)
}

/**
 * Returns the coordinates of the display area
 */
export const getDisplayCoords = (viewport: {
  width: number,
  height: number,
}): { left: number, right: number, top: number, bottom: number } => {
  const { width, height } = viewport
  const v = new PerspectiveMercatorViewport({ ...viewport })
  const [left, top] = v.unproject([0, 0])
  const [right, bottom] = v.unproject([width, height])
  return { left, right, top, bottom }
}

export const fitToBounds = (viewport: viewportType, bounds: boundsType) => {
  let { longitude, latitude } = viewport
  const { lat, lng } = bounds
  let { left, right, top, bottom } = getDisplayCoords(viewport)

  if (left < lng[0]) {
    longitude += lng[0] - left
  }

  if (right > lng[1]) {
    longitude -= right - lng[1]
  }

  if (top > lat[1]) {
    latitude -= top - lat[1]
  }

  if (bottom < lat[0]) {
    latitude += lat[0] - bottom
  }

  return {
    longitude,
    latitude,
  }
}

export const isCoordVisible = (
  viewport: viewportType,
  { lat, lng }: { lat: number, lng: number }
) => {
  const { left, right, top, bottom } = getDisplayCoords(viewport)
  return lng > left && lng < right && lat < top && lat > bottom
}

export default Map
